import { useMemo } from "react";
import InvoiceListResponse from "../../models/serviceApi/InvoiceListResponse";
import InvoiceList from "../../models/domain/InvoiceList";
import useRemoteResource from "../remoteResource/useRemoteResource";
import InvoiceListMapper from "../../mappers/InvoiceListMapper";
import Path, { StringMap } from "../../models/ui/Path";
import utils from "../../Utils";
import RemoteResource from "../remoteResource/RemoteResource";

export default function useInvoiceList(
  query: StringMap = {},
): RemoteResource<InvoiceList> {
  const userProfile = utils.retrieveUserProfile();

  const path = useMemo(() => {
    if (!userProfile?.clinicId) return null;

    return new Path(
      ["api", "v1", "users", "invoices", userProfile.clinicId],
      query,
    ).toString();
  }, [userProfile?.clinicId, query]);

  const { error, isLoading, resource, refresh } =
    useRemoteResource<InvoiceListResponse>(path);

  const mappedResource = useMemo(
    () =>
      resource ? InvoiceListMapper.mapResponseToModel(resource) : undefined,
    [resource],
  );

  return {
    resource: mappedResource,
    isLoading,
    error,
    refresh,
  };
}
